import { FOOTER_LINKS } from "../data";
import { trackContactClick, trackStoreClick } from "../analytics";
import { useSectionTrack } from "../hooks/useSectionTrack";

function FooterCol({ title, links, onLinkClick }) {
  return (
    <div>
      <div className="footer-col-title">{title}</div>
      {links.map(([href, label]) => (
        <a
          key={label}
          href={href}
          target={href.startsWith("http") ? "_blank" : undefined}
          rel="noreferrer"
          className="footer-link"
          onClick={() => onLinkClick && onLinkClick(href, label)}
        >
          {label}
        </a>
      ))}
    </div>
  );
}

export default function Footer() {
  const ref = useSectionTrack("footer");

  const handleAppLink = (href, label) => {
    const store = label.toLowerCase().includes("app store") ? "apple" : "google";
    trackStoreClick(store, "footer");
  };

  const handleContactLink = (href, label) => {
    const type = href.startsWith("mailto")              ? "email"
               : label.toLowerCase().includes("telegram") ? "telegram"
               : label.toLowerCase().includes("instagram") ? "instagram"
               : "other";
    trackContactClick(type, "footer");
  };

  return (
    <footer
      ref={ref}
      className="footer-outer"
      style={{
        padding: "64px 80px 40px",
        background: "transparent",
        borderTop: "1px solid rgba(255,255,255,.08)",
      }}
    >
      <div className="footer-layout">
        <div>
          <a href="/" className="footer-brand">
            <img src="/logo.png" alt="Wychodzi" style={{ width: 36, height: 36, borderRadius: 9, objectFit: "cover" }} />
            <span className="footer-brand-name">Wychodzi</span>
          </a>
          <p className="footer-tagline">
            Приложение для своих. Не корпоративный нетворкинг, не свидания. Просто люди, которым есть куда пойти.
          </p>
        </div>
        <FooterCol title="Приложение" links={FOOTER_LINKS.app}      onLinkClick={handleAppLink} />
        <FooterCol title="Контакты"   links={FOOTER_LINKS.contacts} onLinkClick={handleContactLink} />
      </div>

      <div className="footer-divider">
        <div className="footer-legal">
          <span className="footer-copy">© 2026 Wychodzi</span>
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
            {FOOTER_LINKS.legal.map(([href, label]) => (
              <a key={label} href={href} className="footer-legal-link">{label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
